import { useState } from 'react';
import {
  Box,
  Separator,
  Text,
  Checkbox,
  Flex,
  Button,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import api from '@services/api';

import groupRoles from '../utils/groupRoles';
import { GROUP_LABELS } from '../utils/groupLabels';
import type { RoleType } from '../type';

type Props = {
  rolesList: RoleType[],
  userRoles: string[],
};

const List = ({ rolesList, userRoles }:Props) => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [rolesChecked, setRolesChecked] = useState<string[]>([...userRoles]);

  const groupedRoles = groupRoles(rolesList);
  const groupCategories = Object.keys(groupedRoles);

  const handleWithCheckboxChange = (roleId: string) => {
    if (rolesChecked.includes(roleId)) {
      setRolesChecked(rolesChecked.filter((id) => id !== roleId));
    } else {
      setRolesChecked([...rolesChecked, roleId]);
    }
  };

  const onSaveClick = async () => {
    try {
      setLoading(true);
      const response = await api.put(`/user/${id}/roles`, {
        roles: rolesChecked,
      });

      if (response?.status === 200) {
        toast.success('Cliente editado com sucesso!');
      } else {
        toast.error('Erro ao editar as permissões.');
      }
    } catch {
      toast.error('Erro ao editar as permissões.');
    } finally {
      setLoading(false);
    };
  };

  return (
    <Box>
      {groupCategories.map((category) => (
        <Box key={category} mb={14}>
          <Text fontSize="md" fontWeight={500}>
            {GROUP_LABELS[category]}
          </Text>
          <Separator mt={1} mb={4} opacity={0.5} />

          <Grid templateColumns="repeat(12, 1fr)" gapX={10} gapY={5}>
            {groupedRoles[category].map((role) => (
              <GridItem colSpan={{ base: 12, sm: 6, lg: 4, xl: 3 }} key={role.id}>
                <Checkbox.Root
                  checked={rolesChecked.includes(role.id)}
                  onCheckedChange={() => handleWithCheckboxChange(role.id)}
                  cursor="pointer"
                >
                  <Checkbox.HiddenInput />
                  <Checkbox.Control colorPalette="argos" />
                  <Checkbox.Label fontWeight={400}>
                    {role.name}
                  </Checkbox.Label>
                </Checkbox.Root>
              </GridItem>
            ))}
          </Grid>
        </Box>
      ))}

      <Flex justify="flex-end">
        <Button loading={loading} onClick={onSaveClick}>
          Salvar alterações
        </Button>
      </Flex>
    </Box>
  );
};

export default List;
